<template>
  <section
    class="step-content"
    :class="[{'step-content--column': column}, width]"
  >
    <!-- :class="width" -->
    <slot/>
  </section>
</template>

<script>
/**
 * <step-content></step-content>
 * @desc Container for the content of each step
 */
export default {
  // Name
  name: 'step-content',

  // Props
  props: {
    width: String,
    column: Boolean
  }
}
</script>

<style scoped lang="scss">
.step-content {
  max-width: 100%;
  margin: 0 15px;

  @include breakpoint('tablet-portrait-up') {
    margin: auto;
    width: 560px;
  }

  @include breakpoint('tablet-landscape-up') {
    display: flex;
    justify-content: center;
    align-items: center;

    &.xs {
      width: 275px;
    }

    &.sm {
      width: 385px;
    }

    &.md {
      width: 560px;
    }

    &.lg {
      width: 650px;
    }

    &.xl {
      width: 845px;
    }

  }

  @include breakpoint('desktop-up') {
    display: flex;
    &:after {
      /**
      * IE Flex workaround
      * https://github.com/philipwalton/flexbugs/issues/231
      */
      content: '';
      min-height: inherit;
      max-height: 0px;
      font-size: 0;
      height: 0;
    }

    min-height: 320px;

    &.xs {
      width: 385px;
    }

    &.sm {
      width: 575px;
    }

    &.md {
      width: 645px;
    }

    &.lg {
      width: 780px;
    }

    &.xl {
      width: 970px;
    }
  }

  &--column {
    flex-direction: column;
    min-height: 0;
    flex-flow: row wrap;
  }
}
</style>
